import {
  CommonModule,
} from '@angular/common';
import {
  NgModule,
} from '@angular/core';
import {
  MatButtonModule,
} from '@angular/material/button';
import {
  RouterModule,
} from '@angular/router';
import {
  OrderStoreModule,
} from '@des/store/order';
import {
  OrderEligibilitiesStoreModule,
} from '@des/store/order-eligibilities';
import {
  TrackEventsModule,
} from '@o3r/analytics';
import {
  C11nDirective,
  PlaceholderModule,
} from '@o3r/components';
import {
  LocalizationModule,
} from '@o3r/localization';
import {
  BackToMmbPresModule,
  RefundTeaserContModule,
} from '@refx/servicing-components';
import {
  BasicLayoutModule,
  GenericErrorPanelContModule,
  MessageDisplayPresModule,
  MessagesPanelPresModule,
} from '@refx/shared-components';
import {
  UiMessageModule,
} from '@refx/shared-services';
import {
  UiStatusStoreModule,
} from '@refx/shared-store';
import {
  RecoveryComponent,
} from './recovery.component';

@NgModule({
  declarations: [RecoveryComponent],
  exports: [RecoveryComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: RecoveryComponent
      }
    ]),
    LocalizationModule,
    UiMessageModule,
    MessagesPanelPresModule,
    MatButtonModule,
    BasicLayoutModule,
    TrackEventsModule,
    OrderStoreModule,
    OrderEligibilitiesStoreModule,
    RefundTeaserContModule,
    GenericErrorPanelContModule,
    BackToMmbPresModule,
    C11nDirective,
    PlaceholderModule,
    UiStatusStoreModule,
    MessageDisplayPresModule
  ]
})
export class RecoveryModule {}
